export const initProfileDescription = (): void => {
  const profile = document.getElementById("profile") as HTMLDivElement;

  if (!profile) {
    return;
  }

  const descriptionWrapper = profile.querySelector(".description-wrapper") as HTMLElement;

  if (!descriptionWrapper) {
    return;
  }

  const description = descriptionWrapper.querySelector(".description") as HTMLElement;
  const descriptionFull = descriptionWrapper.querySelector(".description-full") as HTMLElement;
  const buttonReadMore = descriptionWrapper.querySelector(".read-more") as HTMLElement;
  const buttonReadLess = descriptionWrapper.querySelector(".read-less") as HTMLElement;

  if (!description || !descriptionFull || !buttonReadMore || !buttonReadLess) {
    return;
  }

  buttonReadMore.addEventListener("click", (e: Event) => {
    e.preventDefault();

    description.classList.add("d-none");
    buttonReadMore.classList.add("d-none");

    descriptionFull.classList.remove("d-none");
    buttonReadLess.classList.remove("d-none");
  });

  buttonReadLess.addEventListener("click", (e: Event) => {
    e.preventDefault();

    description.classList.remove("d-none");
    buttonReadMore.classList.remove("d-none");

    descriptionFull.classList.add("d-none");
    buttonReadLess.classList.add("d-none");
  });
};

document.addEventListener("DOMContentLoaded", initProfileDescription);
